/**
 *  门户排行
 *  2017-11-21
 *  Bai.Zhiming
 */
"use strict";
angular.module("portalRankingModule", []).
controller("portalRankingCtrl", ["$scope", "$q", "trsHttpService", "rankingList", function($scope, $q, trsHttpService, rankingList) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化状态
	 * @return {[type]} [description]
	 */
	function initStatus() {
		$scope.status = {
			rankingTabs: "人民网",
			//新浪初始化标题
			rankingSinaTitle: rankingList.sinaTitle(),
			rankingTitle: rankingList.tabTitle(),
			sinaAcitve: rankingList.sinaTitle()[0],
			readCurve: '',
			//初始化大图长宽
			initBigRankingwidth: {
				height: '240px',
				width: '1000px'
			},
			//初始化人物榜单TAB
			showReadingCurve: false,
			//是否显示排名曲线
			showClick: false,
			//初始化小图长宽高度
			jumpToPageNum: 1,
			//显示标题
			whichTabShow: "",
			//显示二级标题
			showSecondTab: "推荐",
		};
		$scope.data = {
			//初始化门户列表
			rankingTabList: rankingList.childTitle(),
			rankingTabListNum: [],
		};
		$scope.page = {
			"startpage": 1,
			"PAGESIZE": 20
		};
		$scope.params = {
			pagesize: $scope.page.PAGESIZE,
			startpage: $scope.page.startpage,

		};
		initranking();
	}
	/**
	 * [ranklistDetail description] 门户详情排行榜
	 * @params channel   [description]站点名称，使用URLEncoder，比如%E5%86%9B%E4%BA%8B
	 */
	$scope.ranklistTab = function(channel) {
		$scope.status.showSecondTab = channel.CATEGORY;
		$scope.page.startpage = 1;
		$scope.status.jumpToPageNum = 1;
		if($scope.status.rankingTabs == '新浪') {
			$scope.status.curchannelName = channel.CATEGORY != '推荐' ? $scope.status.sinaAcitve.title + '-' + channel.CATEGORY : $scope.status.sinaAcitve.title + '-' + "推荐";
		}
		var params = $scope.status.rankingTabs == '新浪' ? $scope.status.curchannelName : channel.CHANNEL;
		ranklistListDetail(params);
		$scope.status.sinaStatus = {
			channel: channel.CATEGORY
		};
	};
	/*
	 *plancenterdetail[ description] 人物排行榜弹出
	 *@params channel   [description]url名称
	 */
	$scope.plancenterdetail = function(item) {
		var router;
		if(item.ZYZX == 'true') {
			router = $state.href('resourcedetail', {
				guid: item.GUID,
				channel: 'wz',
				indexname: 'website_formal'
			});
		} else {
			router = item.URLNAME;
		}

		window.open(router);
	};
	/**
	 * [ initranking description] 初始化门户列表
	 *
	 */
	function initranking() {
		$scope.data.rankingTabListNum = $scope.data.rankingTabList[0];
		ranklistListDetail($scope.data.rankingTabListNum[0].CHANNEL);
	}
	/**
	 * [ ranklistDetail description] 门户详情排行榜
	 * @params rankingTitle   [description]标签名称obj 
	 */
	$scope.titletab = function(rankingTitle) {
		$scope.status.whichTabShow = rankingTitle.name
		$scope.status.showSecondTab = "推荐";
		$scope.status.rankingTabs = rankingTitle.name;
		$scope.status.showReadingCurve = rankingTitle.showReadingCurve; //是否显示阅读曲线
		$scope.status.showClick = rankingTitle.showClick; //是否显示点击数
		$scope.status.sinaStatus.channel = '推荐';
		$scope.page.startpage = 1;
		$scope.status.jumpToPageNum = 1;
		$scope.data.rankingTabListNum = $scope.data.rankingTabList[rankingTitle.value];
		ranklistListDetail($scope.data.rankingTabList[rankingTitle.value][0].CHANNEL).then(function(data) {
				if(data.sitename === "新浪") {
					$scope.status.sinaStatus = {
						channel: "推荐",
						name: "推荐",
					};
				}
			});
	};
	/*
	 *[  mediaReplace description] 门户排行榜媒体下去掉括号
	 *@params item   [description]媒体名称
	 */
	function mediaReplace(item) {
		$scope.status.SRCNAME = [];
		var objNull = "";
		for(var i = 0; i < item.length; i++) {
			if(item[i].SRCNAME === null || item[i].SRCNAME === '') {
				$scope.status.SRCNAME.push(objNull);
			} else {
				var media = item[i].SRCNAME.replace('\(', '');
				media = media.replace('\)', '');
				$scope.status.SRCNAME.push(media);
			}
		}
	}
	/*
	 *[titletab description] 门户排行榜Tab按钮
	 *@params SinaTitle   [description]站点名称，使用URLEncoder，比如%E5%86%9B%E4%BA%8B
	 */
	$scope.sinaNewsRanking = function(SinaTitle, index) {
		$scope.status.sinaAcitve = SinaTitle;
		var channel = "";
		var type = "";
		var rankTab = index + 1;
		// $scope.data.rankingTabListNum = [];
		switch(index) {
			case 0:
				// $scope.data.rankingTabListNum = angular.copy($scope.status.ranklistRigthBth[rankTab]);
				if($scope.status.curchannelName != '推荐' && $scope.status.curchannelName) {
					channel = '评论数排行' + '-' + $scope.status.curchannelName.split('-').pop();
				} else {
					channel = "评论数排行-推荐";
				}
				type = "评论数排行";
				$scope.status.sinaStatus.name = "评论数";
				break;
			case 1:
				// $scope.data.rankingTabListNum = angular.copy($scope.status.ranklistRigthBth[rankTab]);
				if($scope.status.curchannelName != '推荐' && $scope.status.curchannelName) {
					channel = '点击量排行' + '-' + $scope.status.curchannelName.split('-').pop();
				} else {
					channel = "点击量排行-推荐";
				}
				type = "点击量排行";
				$scope.status.sinaStatus.name = "阅读数";
				break;
			case 2:
				// $scope.data.rankingTabListNum = angular.copy($scope.status.ranklistRigthBth[rankTab]);
				if($scope.status.curchannelName != '推荐' && $scope.status.curchannelName) {
					channel = '分享数排行' + '-' + $scope.status.curchannelName.split('-').pop();
				} else {
					channel = "分享数排行-推荐";
				}
				type = "分享数排行";
				$scope.status.sinaStatus.name = "分享数";
				break;
			
		}
		ranklistListDetail(channel, type).then(function(data) {
			$scope.status.sinaStatus.type = data.type;
		});
	};
	/**
	 * [ranklistDetail description] 门户详情排行榜
	 * @params channel   [description]站点名称，使用URLEncoder，比如%E5%86%9B%E4%BA%8B
	 */
	function ranklistListDetail(channel, type) {
		$scope.status.sinaStatus = {
			channel: channel
		};
		var defer = $q.defer();
		var ranking = {
			typeid: "widget",
			serviceid: "portallist2",
			modelid: "getinfolist",
			sitename: $scope.status.rankingTabs,
			channel: channel,
			type: type,
			pagesize: $scope.page.PAGESIZE,
			page_no: $scope.page.startpage - 1,
			loadtime: $scope.params.search_date,
		};

		if($scope.status.rankingTabs == "新浪" && ranking.type === undefined) {
			if(angular.isDefined($scope.status.sinaAcitve)) {
				ranking.type = $scope.status.sinaAcitve.title;
				ranking.channel = ranking.channel == '推荐' ? $scope.status.sinaAcitve.title + '-' + '推荐' : ranking.channel;
			} else {
				ranking.type = "点击量排行";
				ranking.channel = "点击量排行-推荐";
			}
			defer.resolve(ranking);
		} else {
			ranking.type = type;
		}
		$scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), ranking, "get").then(function(data) {
			$scope.data.ranklistLists = data.CONTENT.RESULT.CONTENT;
			$scope.data.ranklistLists.name = angular.copy(data.CONTENT.RESULT.CONTENT[0].ORDERNAME);
			mediaReplace(data.CONTENT.RESULT.CONTENT);
			$scope.page = {
				startpage: data.CONTENT.RESULT.NUMBER + 1,
				PAGESIZE: data.CONTENT.RESULT.SIZE,
				ITEMCOUNT: data.CONTENT.RESULT.TOTALELEMENTS,
				PAGECOUNT: data.CONTENT.RESULT.TOTALPAGES
			};

		});
		return defer.promise;
	}
	/**
	 * [pageChanged description]分页请求
	 * @return {[type]} [description]
	 */
	$scope.pageChanged = function() {
		$scope.status.jumpToPageNum = $scope.page.startpage;
		$scope.params.page_no = $scope.page.startpage - 1;
		ranklistListDetail($scope.status.sinaStatus.channel);
	};
	$scope.jumpToPage = function() {
		if($scope.status.jumpToPageNum > $scope.page.PAGECOUNT) {
			$scope.status.jumpToPageNum = $scope.page.PAGECOUNT;
		}
		$scope.params.page_no = $scope.status.jumpToPageNum - 1;
		$scope.page.startpage = $scope.status.jumpToPageNum;
		ranklistListDetail($scope.status.sinaStatus.channel);
	};
	/**
	 * [initData description]  初始化数据
	 * @return {[type]} [description]
	 */
	function initData() {
		$scope.status.whichTabShow = $scope.status.rankingTitle[0].name;
	}
	/**
	 * 获取筛选时间
	 * @param {Object} item
	 */
	$scope.chooseTime = function() {
		if($scope.status.STARTTIME) {
			var st = $scope.status.STARTTIME.replace(new RegExp("-","gm"),"/");
			var et = $scope.status.ENDTIME.replace(new RegExp("-","gm"),"/");
			$scope.params.search_date = st + ";" + et;
		} else {
			$scope.params.search_date = '';
		}
		ranklistListDetail($scope.status.sinaStatus.channel);
	}
}]);